import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="badge-embed"
//
// Picks which badge variant is previewed and which snippet is copyable. Every
// variant is rendered server-side, so this only shows one and hides the rest.
export default class extends Controller {
  static targets = ["snippet", "preview", "hint", "appearancePicker"];
  static values = {
    snippets: Object,
    hints: Object,
    format: String,
    appearance: String,
  };

  selectFormat(event) {
    this.formatValue = event.target.value;
  }

  selectAppearance(event) {
    this.appearanceValue = event.target.value;
  }

  formatValueChanged() {
    this.#render();
  }

  appearanceValueChanged() {
    this.#render();
  }

  #render() {
    // Values change once before the targets exist; the server-rendered state
    // is already correct at that point.
    if (!this.hasSnippetTarget) return;

    const variant = `${this.formatValue}:${this.appearanceValue}`;

    this.snippetTarget.textContent = this.snippetsValue[variant];
    this.previewTargets.forEach((preview) => {
      preview.hidden = preview.dataset.badgeEmbedVariant !== variant;
    });

    if (this.hasHintTarget) {
      this.hintTarget.textContent = this.hintsValue[this.formatValue];
    }

    // A plain text link has no dark or light version to choose.
    if (this.hasAppearancePickerTarget) {
      this.appearancePickerTarget.disabled = this.formatValue === "link";
    }
  }
}
